import { useState } from 'react'
import { useNavigate, Navigate } from 'react-router'
import { useAdminAuth } from '../context/AdminAuthContext'

export default function Login() {
  const { login, isAuthenticated } = useAdminAuth()
  const navigate = useNavigate()

  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState(null)
  const [loading,  setLoading]  = useState(false)

  if (isAuthenticated) return <Navigate to="/" replace />

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await login(email, password)
      navigate('/')
    } catch (err) {
      setError(err.response?.data?.message ?? 'Error al iniciar sesión.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: 'var(--bg)',
    }}>
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: '14px', padding: '40px', width: '380px',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '32px' }}>
          <div className="logo-icon">e</div>
          <div>
            <div className="logo-text">e<span>Factura</span> Backoffice</div>
            <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '2px' }}>Panel de administración</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div className="form-group">
            <label className="form-label">Correo electrónico</label>
            <input
              className="form-input"
              type="email"
              placeholder="admin@efactura.sv"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <input
              className="form-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div className="error-banner">{error}</div>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ justifyContent: 'center', marginTop: '4px' }}
            disabled={loading}
          >
            {loading ? 'Iniciando sesión…' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  )
}
